import React, { Fragment, useEffect, useState } from 'react';


const BiButton = (props) => {

    let dod = {
        margin: props.margin == null ? "" : (props.margin),
        width: props.width == null ? "" : ((props.width.replace("px", "")) + "px"),
        height: props.height == null ? "30px" : ((props.height.replace("px", "")) + "px"),
    }
    if (props.width != null && props.width.indexOf("%") > -1) {
        dod.width = props.width;
    }

    const onClickB = (e) => {
        if (props.onClick != null) {
            props.onClick(e);
        }
    }

    return (



        <button
            disabled={props.disabled ? "disabled" : ""}
            className={(props.className == null ? "btn-outline-secondary" : props.className) + " btn btn-sm"}
            style={{ ...props.style, ...dod }}
            type="button"

            onClick={onClickB}>
            <Fragment>
                {props.icon &&
                    <i className={props.icon} > </i>}
                {props.children &&
                    <span style={{ marginLeft: "4px" }}>{props.children}</span>
                }
            </Fragment>
        </button>
    );
}

export default BiButton;

